"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SwitchInput = void 0;
const i18n_1 = require("../../i18n");
const mithril_1 = require("../../mithril");
const theme_1 = require("../theme");
const switch_input_style_1 = require("./switch.input.style");
(0, theme_1.addStyles)(switch_input_style_1.Style);
function toggleState(state) {
    state.setValue(!state.value);
    state.setFocused(true);
    state.setFocused(false);
}
exports.SwitchInput = {
    view(state) {
        const checked = Boolean(state.value);
        return (0, mithril_1.m)('div', { className: switch_input_style_1.CSS.container }, [
            (0, mithril_1.m)('label', { for: state.id, className: switch_input_style_1.CSS.label }, [
                (0, mithril_1.m)('input', { type: 'checkbox', className: switch_input_style_1.CSS.input, id: state.id, checked, onchange: () => toggleState(state) }),
                (0, mithril_1.m)('span', { className: switch_input_style_1.CSS.slider })
            ]),
            (0, mithril_1.m)('span', (0, i18n_1.Translate)(checked ? i18n_1.T.YES : i18n_1.T.NO))
        ]);
    }
};
//# sourceMappingURL=switch.input.js.map